import { createContext } from 'react';

export const DisplayNamesLastFirstContext = createContext(false);
